import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditActivity = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [activityData, setActivityData] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [, setActivityValue] = useState('');
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...activityData };
    item[name] = value;
    setActivityData(item);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (activityData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        activityData['name'] = props.activity['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/activity/update`, activityData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.activities();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    activityData['name'] = props.activity['name'];
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    setActivityData(props.activity);
  }, [props.activity]);

  return (
    <>
      <EditButtonIcon
        title={props.t('update_activity')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_activity')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={activityData['name']}
                    onChange={(event) => setActivityValue(event.target.value)}
                    placeholder={props.t('placeholder_activity_name')}
                  />
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditActivity);
